/* eslint-disable */
import '../../../../../mu-plugins/lrg-membership/resources/assets/scripts/stripe-for-membership.js'
/* eslint-enable */